/**
 * Central place for all browser storage keys used by the app.
 */
export const StorageKeys = {
  rememberedEmail: 'rememberedEmail',
  logoutState: 'logoutState',
  termsVersion: 'termsVersion'
} as const;
